/** @type {{ [K in import('./types').AppointmentTaskTypeEnum]: K }} */
export const APPOINTMENT_TASK_TYPES = {
  KEY_DEPOSIT: 'KEY_DEPOSIT',
  KEY_RETRIEVE: 'KEY_RETRIEVE',
  REPAIR_ORDER: 'REPAIR_ORDER',
  DRIVER_DOCUMENTS: 'DRIVER_DOCUMENTS',
  BILLING: 'BILLING',
  RENTAL_CAR: 'RENTAL_CAR',
};

export const APPOINTMENT_STATUSES = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
};

/** @type {Record<import('types/Dealer').KeyDepositCustomMessageTypeEnum, import('types/Dealer').KeyDepositCustomMessageTypeEnum>} */
export const CUSTOM_MESSAGE_TYPES = {
  VAULT_ACCESS: 'VAULT_ACCESS',
  CLIENT_VEHICLE_DEPOSIT: 'CLIENT_VEHICLE_DEPOSIT',
  CLIENT_VEHICLE_RETRIEVE: 'CLIENT_VEHICLE_RETRIEVE',
  RENTAL_VEHICLE_DEPOSIT: 'RENTAL_VEHICLE_DEPOSIT',
  RENTAL_VEHICLE_RETRIEVE: 'RENTAL_VEHICLE_RETRIEVE',
};

export const LOCKER_STATUS = {
  TO_START: 'TO_START',
  PREPARED: 'PREPARED',
  CHECKED: 'CHECKED',
};

export const TASK_KEY_STATUS = {
  DROPPED: 'DROPPED',
  PICKED: 'PICKED',
};
